import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow?: string;
  eyebrowIcon?: string;
  title: string;
  desc?: string;
  action?: ReactNode;
  tone?: "light" | "dark";
}

export default function SectionHeading({
  eyebrow,
  eyebrowIcon,
  title,
  desc,
  action,
  tone = "light",
}: SectionHeadingProps) {
  const isDark = tone === "dark";
  return (
    <div className="mb-8 flex flex-col gap-5 md:mb-10 md:flex-row md:items-end md:justify-between">
      <div className="max-w-2xl">
        {eyebrow ? (
          <span
            className={`mb-3 inline-flex items-center gap-1.5 text-xs font-medium tracking-wide ${
              isDark ? "text-accent-300" : "text-primary-600"
            }`}
          >
            {eyebrowIcon ? (
              <span className="flex h-3.5 w-3.5 items-center justify-center">
                <i className={eyebrowIcon}></i>
              </span>
            ) : null}
            {eyebrow}
          </span>
        ) : null}
        <h2
          className={`font-heading text-2xl font-bold leading-tight md:text-[32px] ${
            isDark ? "text-background-50" : "text-foreground-950"
          }`}
        >
          {title}
        </h2>
        {desc ? (
          <p
            className={`mt-3 text-sm leading-relaxed md:text-[15px] ${
              isDark ? "text-background-200" : "text-foreground-600"
            }`}
          >
            {desc}
          </p>
        ) : null}
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  );
}